export default __webpack_public_path__ + "static/design_mobile_reversed-poster-73db03bb825f787d78bac81fdcb11fd3.avif";